import type { ReactNode } from 'react';
import { OverlayScrollArea } from '@odo/shared-ui';

interface ConfirmModalBodyProps {
    /** Spacing between the body's sections, e.g. 'space-y-3'. */
    className: string;
    children: ReactNode;
}

// Scrolls between ConfirmModalHeader and ConfirmModalFooter when the shell hits its viewport cap.
export function ConfirmModalBody({ className, children }: ConfirmModalBodyProps) {
    return (
        <OverlayScrollArea
            className="min-h-0 flex flex-col"
            contentClassName="px-5 py-4"
            innerClassName={className}
        >
            {children}
        </OverlayScrollArea>
    );
}
